export default "__VITE_ASSET__uI4YJLTl__"